<div class="grid align-items-center">
  <div class="breadcrumb col-12 md:col">
    <h3>
      Schedulazioni per ticket
      {{
        'numero #' + this.targetTicket?.ticket_number + '/' + this.targetTicket?.ticket_subnumber
      }}
    </h3>

    <p-breadcrumb
      [model]="menuItems"
      [home]="home"></p-breadcrumb>
  </div>
</div>

<div class="grid">
  <!-- Tabella -->
  <div class="col-12 lg:col">
    <h4>Lista</h4>
    <p-table
      [paginator]="true"
      [value]="schedules"
      #scheduleTable
      [rows]="25"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [lazy]="true"
      [loading]="loading"
      (onLazyLoad)="fetchSchedules($event)"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
      <ng-template pTemplate="header">
        <tr>
          <th>Data creazione</th>
          <th>Data assegnazione</th>
          <th>Data intervento</th>
          <th>Azienda</th>
          <th>Assegnatario</th>
          <th>Durata (ore)</th>
          <th>Stato</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-schedule>
        <tr>
          <td class="text-center">{{ schedule.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="text-center">{{ schedule.assignment_date | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="text-center">
            {{ schedule.intervention_request_date | date: 'dd/MM/yyyy HH:mm' }}
          </td>

          <td class="text-center">{{ schedule.related_registry?.name }}</td>
          <td class="text-center">
            {{ schedule.assigned_user?.name }} {{ schedule.assigned_user?.last_name }}
          </td>
          <td class="text-center">{{ schedule.duration }}</td>
          <td class="text-center">{{ schedule.related_schedule_status.label }}</td>

          <!-- <td class="text-right">
            <p-button
              (click)="updateSchedule(schedule.id)"
              pTooltip="Modifica"
              tooltipPosition="bottom"
              styleClass="butt mx-3 treenode-button"
              [rounded]="true"
              icon="pi pi-ellipsis-h"
            />
          </td> -->
          <td>
            <div class="flex flex-row justify-content-end align-items-center gap-2">
              <p-button
                pTooltip="Gestisci allegati della schedulazione"
                *hasGrants="['TICKET-SCHEDULES.U', 'TICKET-SCHEDULES.R']"
                tooltipPosition="bottom"
                icon="pi pi-folder-open"
                styleClass="butt treenode-button"
                [loading]="false"
                (click)="
                  openUploadActions($event, schedule, titleModal(schedule));
                  tbl_menu_attachments.toggle($event)
                "
                [rounded]="true" />
              <p-button
                *hasGrants="['TICKET-SCHEDULES.U', 'TICKET-SCHEDULES.D']"
                (click)="openActions($event, schedule); tbl_menu.toggle($event)"
                pTooltip="Azioni"
                tooltipPosition="bottom"
                styleClass="butt treenode-button"
                [rounded]="true"
                icon="pi pi-ellipsis-h" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            colspan="8"
            class="text-center py-2">
            Nessun risultato.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- FORM -->
  <div
    class="col-12 lg:col-4"
    *hasGrants="['TICKET-SCHEDULES.C', 'TICKET-SCHEDULES.U']">
    <h4>{{ formTitle }}</h4>
    <form
      [formGroup]="scheduleForm"
      (ngSubmit)="save()">
      <div class="formgrid grid anagrafica">
        <!-- <div class="field col-12">
      <h3>Anagrafica</h3>
    </div> -->

        <div class="col-12 mb-3">
          <p-button
            type="button"
            styleClass="butt w-full"
            [rounded]="true"
            (click)="openRegistryModal()">
            <span>Scegli azienda manutenzione*</span>
          </p-button>
          <!-- azienda selezionata -->
        </div>
        <div class="col-12 mb-4">
          <p-button
            type="button"
            styleClass="butt w-full"
            [rounded]="true"
            [ngClass]="{ 'disabled': !scheduleForm.value.related_registry }"
            (click)="openAssignedUserModal()">
            <span>Scegli tecnico assegnatario</span>
          </p-button>
          <!-- tecnico selezionato -->
        </div>

        <div
          class="col-12 skeleton-border flex py-2 px-2"
          *ngIf="scheduleForm.value.related_registry">
          <h4 class="my-0 mr-3">Azienda selezionata:</h4>
          <h4 class="my-0 grey-text">{{ scheduleForm.value.related_registry.name }}</h4>
        </div>
        <div
          class="col-12 skeleton-border flex py-2 px-2"
          *ngIf="scheduleForm.value.assigned_user">
          <h4 class="my-0 mr-3">Tecnico assegnato:</h4>
          <h4 class="my-0 grey-text">
            {{ scheduleForm.value.assigned_user.name }}
            {{ scheduleForm.value.assigned_user.last_name }}
          </h4>
        </div>

        <!-- assignment_date -->
        <div
          class="col-12 my-3"
          [ngClass]="{ 'read-only': isEditMode ? true : false }">
          <label>Data assegnazione*</label>
          <p-calendar
            [firstDayOfWeek]="1"
            dateFormat="dd/mm/yy"
            formControlName="assignment_date"
            selectionMode="single"
            [readonlyInput]="true"
            styleClass="w-full"
            placeholder="Data assegnazione..."
            [showClear]="isEditMode ? false : true"
            appendTo="body"></p-calendar>
          <app-form-errors
            *ngIf="
              scheduleForm.get('assignment_date')?.errors &&
              scheduleForm.get('assignment_date')?.dirty
            "
            [errors]="scheduleForm.get('assignment_date')?.errors"></app-form-errors>
        </div>

        <!-- intervention_request_date -->
        <div class="col-12 mb-3">
          <label>Data intervento*</label>
          <p-calendar
            [firstDayOfWeek]="1"
            dateFormat="dd/mm/yy"
            formControlName="intervention_request_date"
            selectionMode="single"
            [readonlyInput]="true"
            styleClass="w-full"
            placeholder="Data intervento..."
            [showClear]="true"
            appendTo="body"></p-calendar>
          <app-form-errors
            *ngIf="
              scheduleForm.get('intervention_request_date')?.errors &&
              scheduleForm.get('intervention_request_date')?.dirty
            "
            [errors]="scheduleForm.get('intervention_request_date')?.errors"></app-form-errors>
        </div>
        <!-- duration -->
        <div class="col-6 mb-3">
          <label>Durata (minuti)</label>
          <input
            pInputText
            type="number"
            class="w-full"
            formControlName="duration"
            [min]="0" />
          <app-form-errors
            *ngIf="scheduleForm.get('duration')?.errors"
            [errors]="scheduleForm.get('duration')?.errors"></app-form-errors>
        </div>

        <div class="col-6 mb-3">
          <label>Ore</label>
          <input
            [ngClass]="{ 'read-only': true }"
            pInputText
            type="text"
            class="w-full"
            formControlName="hours_minutes"
            [min]="0" />
        </div>

        <!-- schedule_status -->
        <div class="field col-12">
          <label>Stato schedulazione*</label>
          <p-dropdown
            [options]="scheduleStatuses"
            dataKey="id"
            styleClass="w-full"
            formControlName="schedule_status"
            placeholder="Stato..."
            [showClear]="true"
            [emptyMessage]="'Nessun risultato trovato'">
          </p-dropdown>
          <app-form-errors
            *ngIf="
              scheduleForm.get('schedule_status')?.errors &&
              scheduleForm.get('schedule_status')?.dirty
            "
            [errors]="scheduleForm.get('schedule_status')?.errors"></app-form-errors>
        </div>

        <!-- price -->
        <div class="col-12 mb-3">
          <label>Prezzo*</label>
          <input
            pInputText
            type="number"
            class="w-full"
            formControlName="price"
            [min]="0" />
          <app-form-errors
            *ngIf="scheduleForm.get('price')?.errors && scheduleForm.get('price')?.dirty"
            [errors]="scheduleForm.get('price')?.errors"></app-form-errors>
        </div>
        <!-- price -->
        <div class="col-12 mb-3 flex justify-content-between flex-row align-items-center gap-2">
          <label for="customer_appointment">Appuntamento confermato con il cliente</label>
          <div class="flex flex-row align-items-center gap-2">
            <i
              class="pi pi-info-circle mr-2 teal-text"
              pTooltip="Attivando questa opzione si bloccherà lo SLA sul ticket"></i>
            <p-inputSwitch
              inputId="customer_appointment"
              formControlName="customer_appointment"></p-inputSwitch>
          </div>
        </div>
        <!-- remote_support -->
        <div class="col-12 mb-3 flex justify-content-between flex-row align-items-center gap-2">
          <label for="remote_support">Supporto tecnico remoto</label>
          <p-inputSwitch
            inputId="remote_support"
            formControlName="remote_support"></p-inputSwitch>
        </div>
        <!-- notes -->
        <div class="field col-12 mb-3">
          <label>Note</label>
          <textarea
            rows="3"
            class="w-full"
            pInputText
            formControlName="notes"></textarea>
        </div>
        <div class="col-12 my-3 flex flex-row align-items-center justify-content-center gap-3">
          <p-button
            [label]="'Annulla modifica'"
            type="button"
            styleClass="butt"
            [rounded]="true"
            *ngIf="isEditMode"
            (click)="resetForm()"></p-button>
          <p-button
            [label]="'Salva'"
            type="submit"
            styleClass="butt"
            [loading]="isLoading"
            [rounded]="true"
            [disabled]="scheduleForm.invalid"></p-button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-form-debug-inspector
  [formGroup]="scheduleForm"
  [visible]="!environment.production"></app-form-debug-inspector>

<p-menu
  #tbl_menu
  [model]="tbl_actions"
  [popup]="true"
  appendTo="body" />

<p-menu
  #tbl_menu_attachments
  [model]="tbl_attachments"
  [popup]="true"
  appendTo="body" />
